import { render, staticRenderFns } from "./findPwd.vue?vue&type=template&id=33db7dea&scoped=true&"
import script from "./findPwd.vue?vue&type=script&lang=js&"
export * from "./findPwd.vue?vue&type=script&lang=js&"
import style0 from "./findPwd.vue?vue&type=style&index=0&id=33db7dea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33db7dea",
  null
  
)

export default component.exports